import Global from "@/scripts/Global"
import SessionManager from "@/Manager/Session.manager";
import ChannelApi from "@/scripts/api/channel.api";
import ChannelNotification from "@/Manager/Notification/Channel.manager";
import VueSignals from "@/scripts/VueSignals";

export default {
    name: 'DeleteUser',
    data() {
        return {
            currData: {
                'user': ''
            },
            confirmCheck: false,
            userToRemove: Object,
            errorMesage: "",
        }
    },
    mounted() {
        this.currData = this.$parent.data
        if (typeof this.currData.user.user_id != 'undefined' && this.currData.user.user_id.length > 0) {
            this.userToRemove = SessionManager.getUser(this.currData.user.user_id)
            if (typeof this.currData.user.invitation_id == 'undefined') {
                this.userToRemove.invitation_id = this.currData.user.invitation_id
            }

        } else {
            this.userToRemove = this.currData.user
        }
    },
    methods: {
        RemoveUser() {
            if (this.confirmCheck) {
                let active_channel_doc = SessionManager.getActiveChannel()
                ChannelApi.removeUser(SessionManager.getActiveChannelId(), this.userToRemove).then(res => {
                    if (res.data.result) {
                        ChannelNotification.RemoveUser(this.userToRemove, active_channel_doc.channel_id, active_channel_doc.user_ids)
                        Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false)
                    } else {
                        if (res.data.reason == "user_not_admin")
                            this.errorMesage = this.$t("Sorry, You are not an admin");
                    }
                })
            }
        }
    }
}
